import { Modal, Form, Button } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React from "react";
import { updateCompanyBasicInformation } from "../../../../actions/companyActions";
import Voice from "./voiceCard";
import GalkButton from "../../../common/component/button";

const DeleteVoiceModal = ({
	modalCloseHandler,
	updateCompanyBasicInformation,
	voiceList,
	voiceDetails,
}) => {
	const { t } = useTranslation();

	const deleteVoice = () => {
		const oldList = voiceList || [];
		const newList = oldList.filter((x) => x.index !== voiceDetails.index);

		updateCompanyBasicInformation({
			voiceOfSeniors: newList.map((x) => {
				delete x.index;
				return {
					...x,
				};
			}),
		});
		modalCloseHandler();
	};

	return (
		<Modal
			title="Are you sure you want to delete ?"
			visible={true}
			onCancel={modalCloseHandler}
			width={700}
			footer={null}
		>
			<Voice voice={voiceDetails} readOnly={true} />
			<div className="project-form-controls-cont">
				<GalkButton
					type="primary"
					danger
					height={36}
					additionalStyle={{ padding: "13px 16px" }}
					onClick={deleteVoice}
				>
					{t("deleteProject_confirm_modalAction_submit")}
				</GalkButton>
			</div>
		</Modal>
	);
};

export default connect(null, { updateCompanyBasicInformation })(
	DeleteVoiceModal
);
